import { Component, ViewChild } from '@angular/core';
import { Platform, MenuController, Nav, App } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { trigger, style, animate, transition } from '@angular/animations';

import { FirebaseAuthService } from '../pages/firebase-integration/firebase-auth.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: 'app.html',
  animations: [
    trigger(
      'enterAnimation', [
        transition(':enter', [
          style({ transform: 'translateX(100%)', opacity: 0 }),
          animate('500ms', style({ transform: 'translateX(0)', opacity: 1 }))
        ]),
        transition(':leave', [
          style({ transform: 'translateX(0)', opacity: 1 }),
          animate('500ms', style({ transform: 'translateX(100%)', opacity: 0 }))
        ])
      ]
    )
  ]
})
export class MyApp {

  @ViewChild(Nav) nav: Nav;

  // make WalkthroughPage the root (or first) page
  rootPage: any = 'WalkthroughPage';
  textDir: string = "ltr";

  pages: Array<{ title: any, icon: string, component: any }>;
  rootPages: Array<{ title: any, icon: string, component: any }>;

  constructor(
    platform: Platform,
    public menu: MenuController,
    public app: App,
    public splashScreen: SplashScreen,
    public statusBar: StatusBar,
    public fAuthService: FirebaseAuthService,
    public translate: TranslateService
  ) {
    translate.setDefaultLang('en');
    translate.use('en');

    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      
      // Only call Cordova plugins if we're on a mobile platform
      if (platform.is('cordova')) {
        this.splashScreen.hide();
        this.statusBar.styleDefault();
      }
    });

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      if (event.lang == 'ar') {
        platform.setDir('rtl', true);
      }
      else {
        platform.setDir('ltr', true);
      }
      forkJoin(
        this.translate.get('DASHBOARD'),
        this.translate.get('PROFILE'),
        this.translate.get('CART'),
        this.translate.get('PAYMENT'),
        this.translate.get('ORDER_TRACKING'),
        this.translate.get('CODE_SCANNER'),
        this.translate.get('CONTACT_US')
      ).subscribe(data => {
        this.rootPages = [
          { title: data[0], icon: 'apps', component: "DashboardPage" }
        ];

        this.pages = [
          { title: 'Public Profile', icon: 'person', component: 'ProfilePublicPage' },
          { title: data[2], icon: 'cart', component: 'CartPage' },
          { title: "Tribal Credit", icon: 'flame', component: 'TribalCreditPage' },
          { title: data[4], icon: 'paper-plane', component: 'TrackingPage' },
          { title: data[5], icon: 'barcode', component: 'ScannerPage' },
          { title: data[6], icon: 'contact', component: 'ContactUsPage' }
          // { title: 'Job Search', icon: 'briefcase', component: 'JobberApplicationPage' }
        ];
      });
    });

  }

  openPage(page) {
    this.menu.close();
    this.nav.push(page.component);
  }

  setRootPage(page) {
    this.menu.close();
    this.nav.setRoot(page.component);
  }

  logout(): void {
    this.menu.close();

    this.fAuthService.doLogout()
      .then(() => {
        this.nav.setRoot(this.rootPage);
      }, (error) => {
        console.log("Logout error", error);
      });
  }

  goToHomePage() {
    this.nav.setRoot('DashboardPage');
  }
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts